import React from 'react';
import { Mail, Phone, MessageCircle } from 'lucide-react';

const DETAILS = [
  ['date', 'Wedding Date'], ['destination', 'Destination'], ['guests', 'Guests'],
  ['budget', 'Budget'], ['city', 'Lives in'], ['support', 'Support'],
];

const formatDate = (iso) => new Date(iso).toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' });

export default function EnquiryCard({ enquiry: e }) {
  const phoneDigits = (e.phone || '').replace(/\D/g, '');
  return (
    <article data-testid={`enquiry-card-${e.id}`} className="bg-white border-t-2 border-[#c3a66d] p-6 md:p-8 shadow-sm hover:shadow-md transition-shadow">
      <div className="flex flex-col md:flex-row md:items-start justify-between gap-4">
        <div>
          <h2 className="font-serif text-2xl text-[#053e49]">{e.name}{e.partner ? ` & ${e.partner}` : ''}</h2>
          <div className="mt-3 flex flex-wrap gap-x-6 gap-y-2 text-sm text-[#4a5c60]">
            <a href={`mailto:${e.email}`} className="flex items-center gap-2 hover:text-[#a6894f]"><Mail size={14} />{e.email}</a>
            {e.phone && <a href={`tel:${e.phone}`} className="flex items-center gap-2 hover:text-[#a6894f]"><Phone size={14} />{e.phone}</a>}
            {phoneDigits && <a href={`https://wa.me/${phoneDigits}`} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-[#a6894f]"><MessageCircle size={14} />WhatsApp</a>}
          </div>
        </div>
        <div className="text-xs text-[#6b7c80] md:text-right">
          <div>{formatDate(e.created_at)}</div>
          <div className="mt-1 eyebrow text-[#a6894f]">Email {e.email_status}</div>
        </div>
      </div>
      <dl className="mt-6 grid grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-4">
        {DETAILS.filter(([k]) => e[k]).map(([k, label]) => (
          <div key={k}><dt className="eyebrow text-[#a6894f]">{label}</dt><dd className="font-serif text-[#053e49] mt-1">{e[k]}</dd></div>
        ))}
      </dl>
      {e.message && <p className="mt-6 text-[#4a5c60] whitespace-pre-wrap border-l-2 border-[#c3a66d]/40 pl-4">{e.message}</p>}
    </article>
  );
}
